"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$footerTitle = _ref.footerTitle,
    footerTitle = _ref$footerTitle === void 0 ? '' : _ref$footerTitle,
    _ref$footerTitleHref = _ref.footerTitleHref,
    footerTitleHref = _ref$footerTitleHref === void 0 ? '' : _ref$footerTitleHref,
    _ref$advantageList = _ref.advantageList,
    advantageList = _ref$advantageList === void 0 ? [] : _ref$advantageList,
    _ref$caseList = _ref.caseList,
    caseList = _ref$caseList === void 0 ? [] : _ref$caseList,
    _ref$logoList = _ref.logoList,
    logoList = _ref$logoList === void 0 ? [] : _ref$logoList,
    _ref$logoLine = _ref.logoLine,
    logoLine = _ref$logoLine === void 0 ? '1' : _ref$logoLine,
    _ref$logoTitle = _ref.logoTitle,
    logoTitle = _ref$logoTitle === void 0 ? '' : _ref$logoTitle,
    _ref$logoOneLineNum = _ref.logoOneLineNum,
    logoOneLineNum = _ref$logoOneLineNum === void 0 ? '' : _ref$logoOneLineNum;
  const handledList = caseList === null || caseList === void 0 ? void 0 : caseList.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? '' : _ref2$icon,
      _ref2$img = _ref2.img,
      img = _ref2$img === void 0 ? '' : _ref2$img,
      _ref2$btnText = _ref2.btnText,
      btnText = _ref2$btnText === void 0 ? '' : _ref2$btnText,
      _ref2$btnHref = _ref2.btnHref,
      btnHref = _ref2$btnHref === void 0 ? '' : _ref2$btnHref,
      _ref2$list = _ref2.list,
      list = _ref2$list === void 0 ? [] : _ref2$list,
      _ref2$recommends = _ref2.recommends,
      recommends = _ref2$recommends === void 0 ? [] : _ref2$recommends;
    const btnExtendProps = {
      'report-event': 'click_CaseLayout_tab_btn',
      'report-ext1': index,
      'report-ext2': btnText,
      'report-ext3': btnHref || '',
      target: '_blank'
    };
    return {
      text,
      list,
      recommends,
      btns: btnText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        type: 'solid-white',
        align: "center",
        icon: true,
        href: btnHref
      }, btnExtendProps), btnText) : null,
      img: (0, _componentUtils.doComponentsUploadEvent)(img).url,
      icon: (0, _componentUtils.doComponentsUploadEvent)(icon).url
    };
  });
  const handledLogoList = logoList === null || logoList === void 0 ? void 0 : logoList.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      img = _ref3.img,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? '' : _ref3$href,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip;
    const btnExtendProps = {
      'report-event': 'click_CaseLayout_logo_item',
      'report-ext1': index,
      'report-ext2': href || '',
      target: '_blank'
    };
    return {
      tooltip,
      btnExtendProps,
      href,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    };
  });
  return {
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    footerTitle,
    footerTitleHref,
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    porintId,
    logoLine,
    advantageList,
    caseList: handledList,
    logoList: handledLogoList,
    logoTitle,
    logoOneLineNum
  };
};
function splitIntoGroups(arr, groups) {
  if (groups <= 0) return [];
  const len = arr.length;
  if (groups > len) {
    // 处理类型安全的分组
    const filled = arr.map(item => [item]);
    const empty = Array(groups - len).fill([]);
    return [...filled, ...empty];
  }
  const baseSize = Math.floor(len / groups);
  const remainder = len % groups;
  const result = [];
  let start = 0;
  for (let i = 0; i < groups; i++) {
    const chunkSize = baseSize + (i < remainder ? 1 : 0);
    result.push(arr.slice(start, start + chunkSize));
    start += chunkSize;
  }
  return result;
}
;

/**
 * 将数组分成两个部分
 * @param arr 原始数组
 * @param num 第一个数组的长度
 * @returns 返回分割后的结果，如果num超过数组长度则返回原数组
 */
const splitLogoList = (arr, num) => {
  if (!arr || arr.length === 0) {
    return arr;
  }
  if (num >= arr.length) {
    return arr;
  }
  const first = arr.slice(0, num);
  const second = arr.slice(num);
  return [first, second];
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      tag = _formatAdvantageCommo.tag,
      title = _formatAdvantageCommo.title,
      desc = _formatAdvantageCommo.desc,
      footerTitle = _formatAdvantageCommo.footerTitle,
      footerTitleHref = _formatAdvantageCommo.footerTitleHref,
      bg = _formatAdvantageCommo.bg,
      bgColor = _formatAdvantageCommo.bgColor,
      bgImg = _formatAdvantageCommo.bgImg,
      porintId = _formatAdvantageCommo.porintId,
      _formatAdvantageCommo2 = _formatAdvantageCommo.logoLine,
      logoLine = _formatAdvantageCommo2 === void 0 ? '1' : _formatAdvantageCommo2,
      advantageList = _formatAdvantageCommo.advantageList,
      caseList = _formatAdvantageCommo.caseList,
      logoList = _formatAdvantageCommo.logoList,
      logoTitle = _formatAdvantageCommo.logoTitle,
      logoOneLineNum = _formatAdvantageCommo.logoOneLineNum;
    const mun = Number(logoLine);
    let logoListResult = [];
    logoListResult = splitIntoGroups(logoList, mun);
    if (logoOneLineNum) {
      const num = Number(logoOneLineNum);
      const splitResult = splitLogoList(logoList, num);
      logoListResult = Array.isArray(splitResult[0]) ? splitResult : [splitResult];
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-caseLayout"
    }, (0, _reportUtil.reportShow)(['show_newUI_CaseLayout', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg,
      type: 'full',
      footLinks: footerTitle && footerTitleHref ? [{
        children: footerTitle,
        icon: true,
        href: footerTitleHref
      }] : [],
      className: `tpm-product-intl-case-layout__section ${!!logoListResult.length ? 'has-logo' : ''}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLayout, {
      advantageList: advantageList,
      caseList: caseList
    }), !!logoListResult.length && /*#__PURE__*/React.createElement(React.Fragment, null, logoTitle ? /*#__PURE__*/React.createElement(_tpmProductIntl.Panel, {
      title: logoTitle
    }, logoListResult.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLogo, {
      logos: item || []
    }))) : logoListResult.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLogo, {
      logos: item || []
    })))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}